import { FunctionComponent, ReactNode } from 'react';
import { Box } from '@mui/material';

interface IPageWrapper {
	children: ReactNode;
}

export const PageWrapper: FunctionComponent<IPageWrapper> = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				flex: 1,
				minHeight: 0,
				overflow: 'auto',
			}}
		>
			{children}
		</Box>
	);
};
